/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UsdcGate
 */
export interface UsdcGate {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof UsdcGate
     */
    splits: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof UsdcGate
     */
    price: number;
}

/**
 * Check if a given object implements the UsdcGate interface.
 */
export function instanceOfUsdcGate(value: object): value is UsdcGate {
    let isInstance = true;
    isInstance = isInstance && "splits" in value && value["splits"] !== undefined;
    isInstance = isInstance && "price" in value && value["price"] !== undefined;

    return isInstance;
}

export function UsdcGateFromJSON(json: any): UsdcGate {
    return UsdcGateFromJSONTyped(json, false);
}

export function UsdcGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsdcGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'splits': json['splits'],
        'price': json['price'],
    };
}

export function UsdcGateToJSON(value?: UsdcGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'splits': value.splits,
        'price': value.price,
    };
}

